import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {FormGroup, FormControl, FormHelperText, TextField} from '@material-ui/core';
import {Autocomplete} from '@material-ui/lab';
import {formShape} from 'rc-form';
import {isEmpty} from 'lodash/lang';

const AutoSuggestSelect = ({
  name,
  label,
  placeholder,
  rules,
  initialValue,
  form: {getFieldProps, getFieldError, resetFields},
  multiple,
  labelKey,
  onSearch,
  disableClearable,
  filterSelectedOptions,
  onChangeComplete,
}) => {
  const [inputValue, setInputValue] = useState(!multiple && !isEmpty(initialValue) ? initialValue[labelKey] : '');
  const [options, setOptions] = useState([]);

  let errors = getFieldError(name);
  let hasError = !isEmpty(errors);
  let error;
  if (hasError) {
    error = errors[0];
  }

  useEffect(() => {
    return () => {
      getFieldProps(name);
      resetFields([name]);
    };
  }, []);

  useEffect(() => {
    onSearch(inputValue).then(setOptions);
  }, [inputValue]);

  const fieldProps = getFieldProps(name, {
    validate: [{trigger: 'onChange', rules}],
    initialValue,
  });

  return (
    <FormGroup className="mui-form-group">
      <FormControl error={hasError}>
        <Autocomplete
          multiple={multiple}
          options={options}
          getOptionLabel={(option) => option[labelKey]}
          defaultValue={multiple ? initialValue : undefined}
          inputValue={inputValue}
          onInputChange={(eOrValue) => {
            if (eOrValue && eOrValue.target) {
              setInputValue(eOrValue.target.value);
            }
          }}
          onChange={(e, value) => {
            if (!multiple) {
              setInputValue(!isEmpty(value) ? value[labelKey] : '');
            }
            fieldProps.onChange(value);
            onChangeComplete && onChangeComplete(value);
          }}
          onClose={multiple ? () => setInputValue('') : undefined}
          disableCloseOnSelect={multiple}
          disableClearable={disableClearable}
          filterSelectedOptions={filterSelectedOptions}
          renderInput={(props) => (
            <TextField {...props} label={label} placeholder={placeholder} fullWidth autoComplete="off" />
          )}
        />
        <FormHelperText error={hasError}>{error}</FormHelperText>
      </FormControl>
    </FormGroup>
  );
};

AutoSuggestSelect.propTypes = {
  form: formShape.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  rules: PropTypes.array,
  required: PropTypes.bool,
  initialValue: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  labelKey: PropTypes.string,
  valueKey: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  disableClearable: PropTypes.bool,
  filterSelectedOptions: PropTypes.bool,
  onChangeComplete: PropTypes.func,
};

AutoSuggestSelect.defaultProps = {
  initialValue: null,
  labelKey: 'label',
  valueKey: 'value',
  required: false,
  creatable: false,
  multiple: false,
  openOnFocus: true,
  searchPromptText: false,
  loadingPlaceholder: false,
  disableClearable: false,
  filterSelectedOptions: true,
};

export default AutoSuggestSelect;
